module.exports = __webpack_public_path__ + "img/bth_bed_right_tunbu_sel.b8e14c26.png";